<template>
  <div>
    <data-list :payload="listPayloadObj" class="mt-3" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: {
        isactive: true
      },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      loading: false,
      MODULE_URL: 'customershipments',
      pagination: !this.$formatter.isEmptyObject(this.$store.state.CUSTOMER_SHIPMENT_INDEX) ? this.$store.state.CUSTOMER_SHIPMENT_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' }
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true
        // width: '40%'
      }, /* {
        text: this.$t('message.shipment.bring'),
        value: 'bring',
        width: '10%'
      }, {
        text: this.$t('message.shipment.tnt'),
        value: 'tnt',
        width: '10%'
      }, {
        text: this.$t('message.shipment.postnord'),
        value: 'postnord',
        width: '10%'
      },  */{
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '15%'
      }, {
        text: this.$t('message.common.isDefault'),
        value: 'isdefault',
        isBoolean: true,
        sortable: false,
        width: '15%'
      }, {
        text: this.$t('message.common.position'),
        value: 'position',
        sortable: true,
        width: '10%'
      }]
    },
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.shipment.updateShipment') : this.$t('message.shipment.addShipment'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs6'
        }, {
          model: 'position',
          rules: [],
          type: this.FORM_TYPE.NUMBER,
          class: 'xs6',
          label: this.$t('message.common.position')
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isDefault')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        const model = {
          type: 'CUSTOMER_SHIPMENT_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE_URL
      const queryFields = this.$formatter.cloneVariable(this.headers)
      const { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const query = {
        order_by: {
          field: sortBy.join(''),
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((response) => {
          const { values, count } = response.data
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
        })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${id}`)
        .then((result) => {
          if (result.data) this.modelObj = result.data
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.dialog = true
      this.modelObj = { isactive: true }
      if (this.$refs?.fieldsReference?.$refs.validateForm) this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.modelObj
        model.position = model.position || null
        const url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
